import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Reduced to the two namespaces the standalone uses: common (nav/login/status/breadcrumbs/pages) and
// tickets (the validation.* block). en/fr/nl.
//
// FRENCH BY DEFAULT (user ask 2026-08-28). Three things had to change together, because changing the
// default alone would have flipped nobody:
//   1. `navigator` left the detection order. The app is used by a French-speaking team; the browser's
//      language was guessing at something we already know.
//   2. fallbackLng is 'fr'. With nothing detected, i18next falls back — so the fallback IS the default.
//      It also means a key missing from en/nl now shows French rather than English, which for this team
//      is the better failure.
//   3. The storage key was ROTATED (…-language → …-language-fr-default). `caches: ['localStorage']` had
//      already written each user's DETECTED browser language into the old key, and i18next cannot tell a
//      cached detection from a deliberate choice. Without the rotation every existing user would have
//      stayed on whatever their browser said in the first place, and the change would have shipped
//      invisible. The cost is one click for anyone who had genuinely picked English or Dutch.
import enCommon from './locales/en/common.json';
import enTickets from './locales/en/tickets.json';
import frCommon from './locales/fr/common.json';
import frTickets from './locales/fr/tickets.json';
import nlCommon from './locales/nl/common.json';
import nlTickets from './locales/nl/tickets.json';

const resources = {
  en: { common: enCommon, tickets: enTickets },
  fr: { common: frCommon, tickets: frTickets },
  nl: { common: nlCommon, tickets: nlTickets },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    defaultNS: 'common',
    ns: ['common', 'tickets'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'addressval-language-fr-default',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: true,
    },
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});
document.documentElement.lang = i18n.language;

export default i18n;
